import { Customer } from ".";
import { AreaInterestAPI } from "../api";
import moment from 'moment'
import i18n from '@/plugins/vue-i18n';

export class AreaInterest {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    this.marketName = this.market ? this.market.name : ''
    this.areaIds = this.areas?.map(i => i.objectId) || [];
    this.productIds = this.products?.map(i => i.objectId) || [];
    this.productNames = this.products?.map(i => i.name) || [];
    this.imageFiles = this.imageFiles && this.imageFiles.length ? this.imageFiles : []
    if (this.areas.length < this.areasQty) {
      const diff = this.areasQty - this.areas.length;
      for (let i = 0; i < diff; i++) {
        this.areaIds.push("");
      }
    }
    this.createdAtString = moment(props.createdAt).format("DD/MM/YYYY")
    this.contractStartDateString = ""
    if (props.contractStartDate && props.contractStartDate.iso) {
      this.contractStartDateString = moment(props.contractStartDate.iso).format("DD/MM/YYYY")
    }
    this.contractEndDateString = ""
    if (props.contractEndDate && props.contractEndDate.iso) {
      this.contractEndDateString = moment(props.contractEndDate.iso).format("DD/MM/YYYY")
    }
    if (this.quotations && this.quotations.length)
      for (let quotation of this.quotations) {
        quotation.updatedByText = quotation.updatedBy ? `${quotation.updatedBy.firstName} ${quotation.updatedBy.lastName}` : ''
        quotation.updatedAtText = quotation.updatedAt ? moment(quotation.updatedAt).format('DD MMM YYYY, HH:mm') : ''
      }
  }
  get areasString() {
    return [...new Set(this.areas?.map(item => item.name))].join(", ");
  }
  get getStatusString() {
    const status = {
      pending: i18n.t('area_interest.status.pending'),
      approving: i18n.t('area_interest.status.approving'),
      rejected: i18n.t('area_interest.status.rejected'),
      checking: i18n.t('area_interest.status.checking'),
      cancelled: i18n.t('area_interest.status.cancelled'),
      waiting_contract: i18n.t('area_interest.status.waiting_contract'),
      success: i18n.t('area_interest.status.success')
    };
    return status[this.status] || "-";
  }
  get customerTypeString() {
    return this.isNewCustomer ? i18n.t('market.new_customer') : i18n.t('market.old_customer');
  }
  get startDate() {
    return this.contractStartDate?.iso;
  }
  get endDate() {
    return this.contractEndDate?.iso;
  }
  get getCustomerName() {
    if (this.isNewCustomer) {
      if (this.customerType == "personal") {
        return (
          (this?.customerFirstName || "-") +
          " " +
          (this?.customerLastName || "-")
        );
      } else {
        return this?.customerCompanyName || "-";
      }
    } else {
      if (this.customer.type == "personal") {
        return (
          (this.customer?.firstName || "-") +
          " " +
          (this.customer?.lastName || "-")
        );
      } else {
        return this.customer?.companyName || "-";
      }
    }
  }
  get statusColor() {
    const status = {
      pending: "text-blue-500 bg-blue-100",
      approving: "text-purple-500 bg-purple-100",
      rejected: "text-pink-500 bg-pink-100",
      checking: "text-orange-500 bg-orange-100",
      cancelled: "text-red-500 bg-red-100",
      waiting_contract: "text-yellow-500 bg-yellow-100",
      success: "text-green-500 bg-green-100"
    };
    return status[this.status] || "-";
  }
  static async createAreaInterest(postData) {
    const { data } = await AreaInterestAPI.createAreaInterest(postData);
    return new AreaInterest(data.result);
  }
  static async getAreaInterests(payload) {
    const { data } = await AreaInterestAPI.getAreaInterests(payload);
    return data.result.map(item => new AreaInterest(item));
  }
  // get 1
  static async getAreaInterest(areaInterestId) {
    const { data } = await AreaInterestAPI.getAreaInterest(areaInterestId);
    const item = {
      ...data.result
    };
    if (!data.result.isNewCustomer) {
      Object.assign(item, { customer: new Customer(data.result.customer) });
    }
    return new AreaInterest(item);
  }
  static async updateAreaInterest(postData) {
    const { data } = await AreaInterestAPI.updateAreaInterest(postData);
    return new AreaInterest(data.result);
  }
  static async removeAreaInterest(areaInterestId) {
    const { data } = await AreaInterestAPI.removeAreaInterest(areaInterestId);
    return new AreaInterest(data.result);
  }
  static async updateAreaInterestStatus(postData) {
    try {
      const { data } = await AreaInterestAPI.updateAreaInterestStatus(postData);
      return data.result;
    } catch (e) {
      throw e.response.data;
    }
  }
  static async approveAreaInterest(postData) {
    const { data } = await AreaInterestAPI.approveAreaInterest(postData);
    return data.result
  }
  static async rejectAreaInterest(postData) {
    const { data } = await AreaInterestAPI.rejectAreaInterest(postData);
    return data.result
  }
  static async getAreaInterestByArea(payload) {
    const { data } = await AreaInterestAPI.getAreaInterestByArea(payload);
    return data.result.map(item => new AreaInterest(item));
  }
}
